import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { Checkbox, Chip, Colors, IconButton } from 'library';
import { addDays, addWeeks, startOfWeek, subDays, subWeeks } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CalendarColors } from './HiredShift';
import theme from 'theme';
import { useUserContext } from 'UserContext';

export default function CalendarFilters({
    currentDay,
    setCurrentDay,
    showWeekend,
    setShowWeekend,
}: {
    currentDay: Date;
    setCurrentDay: (d: Date) => void;
    showWeekend: boolean;
    setShowWeekend: (show: boolean) => void;
}) {
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const { getDisplayText } = useUserContext();

    function next() {
        const newDate = addWeeks(currentDay, 1);
        setCurrentDay(mdDown ? addDays(currentDay, 1) : startOfWeek(newDate));
    }

    function last() {
        const newDate = subWeeks(currentDay, 1);
        setCurrentDay(mdDown ? subDays(currentDay, 1) : startOfWeek(newDate));
    }

    return (
        <Grid item container direction="row" xs={12} justifyContent="space-around" style={{ marginTop: 20 }}>
            <Grid
                xs={12}
                md={4}
                direction="row"
                item
                container
                justifyContent="flex-end"
                alignItems="center"
                style={{
                    margin: mdDown ? '10px 0px' : 0,
                    justifyContent: mdDown ? 'center' : 'unset',
                }}
            >
                {Object.keys(CalendarColors).map((k: string, index: number) => (
                    <Chip
                        key={k}
                        label={getDisplayText(k.replace('_', ' ').toLowerCase())}
                        style={{
                            marginRight: index === Object.keys(CalendarColors).length ? 0 : 5,
                            textTransform: 'capitalize',
                        }}
                        backgroundColor={CalendarColors[k]}
                    />
                ))}
            </Grid>
            <Grid
                xs={12}
                md={4}
                direction="row"
                item
                container
                style={{ marginBottom: 20, marginTop: mdDown ? 20 : 0, justifyContent: mdDown ? 'center' : 'flex-end' }}
            >
                {!mdDown && (
                    <Checkbox
                        label="Show 7-day week"
                        checked={showWeekend}
                        onChange={setShowWeekend}
                        style={{ width: undefined, marginRight: 20 }}
                    />
                )}
                <IconButton icon={ArrowBackIosIcon} onClick={last} />
                <>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            format="MM/dd/yyyy"
                            value={currentDay}
                            onChange={(d: Date | null) => {
                                if (d) setCurrentDay(d);
                            }}
                            slotProps={{
                                textField: {
                                    variant: 'standard',
                                    InputProps: {
                                        inputProps: {
                                            style: { textAlign: 'center', color: Colors.darkNavy },
                                        },
                                    },
                                },
                            }}
                        />
                    </LocalizationProvider>
                    <IconButton icon={ArrowForwardIosIcon} onClick={next} />
                </>
            </Grid>
        </Grid>
    );
}
